// import "./markup-menu";
import $ from 'jquery'
import sliders from './components/sliders'
import 'jquery-ui';
import datepickerJAFactory from 'jquery-datepicker/i18n/jquery.ui.datepicker-ja';
import gmapInit from './components/map';
import 'jquery-mousewheel'
import 'malihu-custom-scrollbar-plugin'
import Select from './components/select'
import Tabs from './components/tabs'
import handleFilterChange, {yachtPagination} from "./components/yachtFilters";
global.$ = global.jQuery = $
require("./components/open-close");
require("jquery-ui/ui/widgets/datepicker");
require("@fancyapps/fancybox");
document.addEventListener("DOMContentLoaded", () => {
  new Tabs();
  sliders();

  handleFilterChange('.filter__item input');
  yachtPagination('.filter__item input');
  const gmap = document.querySelector('#map') || false;
  if ( gmap ) {
    gmapInit('#map');
  }
  $('.catalog-control__filter').on('click', function() {
    $(this).toggleClass('active');
    $('.filter').toggleClass('show');
  });
  $('.prebook').on('click', function(e) {
    e.preventDefault();
    $('.popup-rent').addClass('active');
  });
  $('.product-inner__buttons .btn-2:not(.gallerypdf)').on('click', function(e) {
    e.preventDefault();
    $('.popup-product').addClass('active');
  });

  $('.popup__close, .popup__overlay').on('click', function() {
    $('.popup').removeClass('active');
  });
  $("#datepicker").datepicker();
  $("#datepicker").focus(function() {
    $(this).parent().addClass('active');
  });
  $('#datepicker').on('blur', function() {
    $(this).parent().removeClass('active');
  });
  if ($(window).width() < 1250) {
    $(".nav").appendTo(".mobile-box");
    $(".lang").appendTo(".mobile-box");
  }
  $(window).resize(function(){
    if ($(window).width() < 1250) {
      $(".nav").appendTo(".mobile-box");
      $(".lang").appendTo(".mobile-box");
    }
    if ($(window).width() < 767) {
      $(".header .callback-box").appendTo(".mobile-box");
    }
  })
  if ($(window).width() < 767) {
    $(".header .callback-box").appendTo(".mobile-box");
  }
  $('.filter__title').on('click', function() {
    $(this).toggleClass('active');
    $(this).siblings().toggleClass('show');
  });
  $('.mobile-opener').on('click', function() {
    $('.mobile-box').toggleClass('active');
    $(this).toggleClass('active');
  });

  $('.intro-inner__video, .review__more--video').on('click', function(e) {
    e.preventDefault();
    const video = $(this).data('video');
    $('.popup-video iframe').attr('src', `https://www.youtube.com/embed/${  video  }?autoplay=1`);
    $('.popup-video').addClass('active');
  });

  $(window).on('scroll', () => {
    const top = $(window).scrollTop();
    if (top > 200) {
      $('.wrapper').addClass('fixed');
    } else {
       $('.wrapper').removeClass('fixed');
    }
  });

  $(".btn-2 .gallerypdf").fancybox({
    openEffect: 'elastic',
    closeEffect: 'elastic',
    autoSize: true,
    type: 'iframe',
    iframe: {
      preload: false
    }
  });

  $('.popup__video-close, .popup__video-overlay').on('click', function(e) {
    e.preventDefault();
    $('.popup-video iframe').attr('src', ``);
    $('.popup-video').removeClass('active');
  });

  $('.video-opener').on('click', function(e) {
    e.preventDefault();
    const video = $(this).data('video');
    $('.video-controls__video iframe').attr('src', `https://www.youtube.com/embed/${  video  }?autoplay=1`);
    $('.video-controls').addClass('active');
  });

  $('.video-controls__overlay, .video-controls__close').on('click', function(e) {
    e.preventDefault();
    $('.video-controls__video iframe').attr('src', ``);
    $('.video-controls').removeClass('active');
  });

  if ($(window).width() > 1250) {
    $("a.back-nav").parents('li').css("display", "none");
    $('.first-list a').on('mouseenter', function openCatalogmenuMenu() {
       const cat = $(this).data('category');
       $('.sub-list').hide();
       $('.third-level').hide();
       $('.catalog-menu__second').find(`.sub-list-${cat}`).fadeIn();
     })

     $('.catalog-holder').on('mouseleave', () => {
       $('.sub-list').fadeOut();
       $('.third-level').fadeOut();
     })
  } else {
    $('.first-list .parent a').on('click', function openCatalogmenuMenu(e) {
       e.preventDefault();
       const cat = $(this).data('category');
       $(this).parents('.catalog-list').addClass('custom');
       $('.sub-list').hide();
       $('.third-level').hide();
       $('.catalog-menu__second').find(`.sub-list-${cat}`).fadeIn();
       $('.catalog-menu__second').addClass('show');
     });
     $('.back-nav').on('click', function () {
       $(this).parents('.catalog-menu__list').css('display', 'none');
       $('.catalog-menu__second').removeClass('show');
       $('.catalog-list').removeClass('custom');
     });
  }

  if ($(window).width() > 1250) {
    $('.basket-drop__list, .catalog-list, .sub-list').mCustomScrollbar();
  }
  global.customSelect = new Select();
  $('.ocf-option-name').on('click', function () {
    $(this).toggleClass('show');
  });

  if ($(window).width() < 767) {
    $(".twocolumns__aside .breadcrumb").insertBefore(".twocolumns");
  }
  $('.mobile-search').on('click', function() {
    $('.search').toggleClass('show');
  });
  $('.search__close').on('click', function() {
    $('.search').removeClass('show');
  });
  $('.btn-cart, .basket-drop__close').on('click', function() {
    $('.basket-drop').toggleClass('show');
  });
  if ($(window).width() < 1250) {
    $(document).on('click', ".catalog-list > ul > li.parent > a", function (e) {
      e.preventDefault();
      $(this).siblings('.second-list').toggleClass('show');
      $(this).parent('li').toggleClass('active');
    });
  }
  $('.login').on('click', function (e) {
    $('.popup-login').addClass('show');
  });

  $('.popup-reg-link').on('click', function (e) {
    $('.popup-login').removeClass('show');
    $('.popup-registration').addClass('show');
  });

  $('.fast-order').on('click', function (e) {
    $('.popup-fast').addClass('show');
  });

  $('.forgot').on('click', function (e) {
    $('.popup-login').removeClass('show');
    $('.popup-forgot').addClass('show');
  });

  $('.popup__close, .popup__overlay, .popup__cancel').on('click', function (e) {
    $('.popup').removeClass('show');
  });
});



// WEBPACK FOOTER //
// app/scripts/index.js